import type { ChatMessage, EnhancedFileCitation } from '../types/chat.types';
import { shouldEnhanceCitations } from './citationFormatting';

export const enhanceMessageCitations = async (
  message: ChatMessage,
  enhanceCitations: (
    citations: EnhancedFileCitation[],
  ) => Promise<EnhancedFileCitation[]>,
): Promise<ChatMessage> => {
  if (!shouldEnhanceCitations(message.citations)) {
    return message;
  }

  try {
    const enhancedCitations = await enhanceCitations(message.citations!);
    return { ...message, citations: enhancedCitations };
  } catch {
    return message; // Keep original citations if enhancement fails
  }
};

export const updateMessageCitations = (
  messages: ChatMessage[],
  messageId: string,
  enhancedMessage: ChatMessage,
): ChatMessage[] => {
  return messages.map(msg => (msg.id === messageId ? enhancedMessage : msg));
};
